// extracted by mini-css-extract-plugin
var _1 = "action-button--UupNK";
var _2 = "delete-action--r_rbd";
var _3 = "reports-management-container--h4jW0";
var _4 = "table-wrapper--FFWcd";
export { _1 as "action-button", _2 as "delete-action", _3 as "reports-management-container", _4 as "table-wrapper" }
